import { render, staticRenderFns } from "./receita_televet.vue?vue&type=template&id=783614ea&scoped=true"
import script from "./receita_televet.vue?vue&type=script&lang=js"
export * from "./receita_televet.vue?vue&type=script&lang=js"
import style0 from "./receita_televet.vue?vue&type=style&index=0&id=783614ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783614ea",
  null
  
)

export default component.exports